<template>
  <div id="base_sort_bar">
    <h2 class="eplist_title">
      <span class="sec_title">{{ currentPageTitle }}</span>
    </h2>
    <div class="eplist_sort">
      <ul class="board_sort">
        <li
          v-for="category in categories"
          :key="category.value"
          :class="{
            active: currentCategory && currentCategory == category.category
          }"
        >
          <a @click="changeCategory(category)">
            <span>{{ category.title }}</span>
          </a>
        </li>
        <li class="active_bar" :style="activeBarStyle"></li>
      </ul>
    </div>
    <div class="eplist_listype">
      <button
        type="button"
        :class="{ active: landscape }"
        class="btn_listype_max"
        @click="landscapeMode"
      >
        <svg viewBox="0 0 16 12" class="svg_listype">
          <path
            d="M1 2H15C15.2652 2 15.5196 1.89464 15.7071 1.70711C15.8946 1.51957 16 1.26522 16 1C16 0.734784 15.8946 0.48043 15.7071 0.292893C15.5196 0.105357 15.2652 0 15 0H1C0.734784 0 0.48043 0.105357 0.292893 0.292893C0.105357 0.48043 0 0.734784 0 1C0 1.26522 0.105357 1.51957 0.292893 1.70711C0.48043 1.89464 0.734784 2 1 2ZM15 5H1C0.734784 5 0.48043 5.10536 0.292893 5.29289C0.105357 5.48043 0 5.73478 0 6C0 6.26522 0.105357 6.51957 0.292893 6.70711C0.48043 6.89464 0.734784 7 1 7H15C15.2652 7 15.5196 6.89464 15.7071 6.70711C15.8946 6.51957 16 6.26522 16 6C16 5.73478 15.8946 5.48043 15.7071 5.29289C15.5196 5.10536 15.2652 5 15 5ZM15 10H1C0.734784 10 0.48043 10.1054 0.292893 10.2929C0.105357 10.4804 0 10.7348 0 11C0 11.2652 0.105357 11.5196 0.292893 11.7071C0.48043 11.8946 0.734784 12 1 12H15C15.2652 12 15.5196 11.8946 15.7071 11.7071C15.8946 11.5196 16 11.2652 16 11C16 10.7348 15.8946 10.4804 15.7071 10.2929C15.5196 10.1054 15.2652 10 15 10Z"
          ></path>
        </svg>
        <span class="blind">{{ $t('views.store.categorybooks.9936') }}</span>
      </button>
      <button
        type="button"
        class="btn_listype_min"
        :class="{ active: !landscape }"
        @click="normalMode"
      >
        <svg viewBox="0 0 18 18" class="svg_listype">
          <path
            d="M17 0H1C0.734784 0 0.48043 0.105357 0.292893 0.292893C0.105357 0.48043 0 0.734784 0 1V17C0 17.2652 0.105357 17.5196 0.292893 17.7071C0.48043 17.8946 0.734784 18 1 18H17C17.2652 18 17.5196 17.8946 17.7071 17.7071C17.8946 17.5196 18 17.2652 18 17V1C18 0.734784 17.8946 0.48043 17.7071 0.292893C17.5196 0.105357 17.2652 0 17 0ZM8 16H2V10H8V16ZM8 8H2V2H8V8ZM16 16H10V10H16V16ZM16 8H10V2H16V8Z"
          ></path>
        </svg>
        <span class="blind">{{ $t('views.store.categorybooks.291') }}</span>
      </button>
    </div>
  </div>
</template>
<script>
export default {
  name: 'DisplayCategoryBar',
  props: {
    currentPageTitle: {
      type: String,
      default: '책리스트'
    },
    currentCategory: {
      type: String,
      default: ''
    },
    categories: {
      type: Array,
      default: () => []
    }
  },
  data() {
    return {
      landscape: true
    }
  },
  computed: {
    activeBarStyle() {
      const idxNo = this.categories.findIndex((x) => {
        return x.category === this.currentCategory
      })
      const idxLen = this.categories.length
      const width = 100 / idxLen
      const left = width * idxNo > 0 ? width * idxNo : 1
      return {
        width: `${width}%`,
        left: `${left}%`
      }
    }
  },
  methods: {
    normalMode() {
      this.$emit('changeMode', false)
      this.landscape = false
    },
    landscapeMode() {
      this.$emit('changeMode', true)
      this.landscape = true
    },
    changeCategory(category) {
      this.$emit('category', category)
    }
  }
}
</script>
<style lang="scss" scoped>
@import '../../../src/assets/scss/_variables.scss';
#base_sort_bar {
  display: grid;
  max-width: 980px;
  margin: 0 auto 0px;
  grid-template-columns: auto 1fr 96px;
  grid-template-areas: 'title sort type';
  align-items: end;

  .eplist_sort,
  .eplist_listype {
    position: static;
  }
  .eplist_sort {
    grid-area: sort;
    padding: 0 14px;
    .board_sort {
      .active {
        span {
          color: $h_sub_point;
        }
      }
      > .active_bar {
        display: none;
      }
      text-align: left;
    }
  }
  .eplist_listype {
    grid-area: type;
    justify-self: end;
  }
  .eplist_title {
    grid-area: title;
  }
}
@media (max-width: 768px) {
  #base_sort_bar {
    grid-template-columns: 1fr 96px;
    margin: 0 0 24px;
    .eplist_sort {
      grid-row: 2/3;
      grid-column: 1/3;
      padding: 0;
      .board_sort {
        > .active_bar {
          display: block;
          position: absolute;
          bottom: 0;
          min-height: 4px;
          height: 4px;
          margin: 0;
          padding: 0;
          transition: all 0.2s;
          border-radius: 3px;
          // max-width: calc(100% / 3);
          background-color: $h_sub_point;
        }
      }
    }
    .eplist_listype {
      grid-row: 1/2;
      grid-column: 2/3;
    }
    .eplist_title {
      grid-row: 1/2;
      grid-column: 1/2;
    }
  }
}
</style>
